import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { Icon } from '@lib/components'

import { IconStyles } from '@lib/components/Icon/styles'

import styles from './styles.module.scss'

export const SafeIndicator = () => {
  const { t } = useTranslation()
  return (
    <>
      <div className={classNames(styles.indicator, styles.safe)}>
        <Icon path="icons/icon-tick" style={IconStyles.small} />
      </div>
      <div className={styles.statusText}>
        {t('Chat.Message.SpamReport.TheMessageIsSafe')}
      </div>
    </>
  )
}
